module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"This site uses third party analytical cookies. Click below to read the privacy policy."},"it":{"title":"Questo sito usa cookie analitici di terze parti. Clicca in basso per leggere l’informativa privacy."}}')
  delete Component.options._Ctor
}
